import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { map } from 'rxjs'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import { Paginate } from '@models/paginate.model'
import { ElectronicProcessBook, ElectronicProcessBookUrl } from '@models/planning/electronic-process-book.model'

/** O pedido do livro: a geração e se ela foi criada agora (202) ou já estava em andamento (200, RF 4). */
export interface ElectronicProcessBookRequestResult {
	book: ElectronicProcessBook
	created: boolean
}

/** Livro eletrônico do processo (`ElectronicProcessBookController` do management, spec 001). */
@Injectable({
	providedIn: 'root'
})
export class ElectronicProcessBookService extends ManagementApiBaseService<unknown> {
	private readonly source = 'electronic-processes'

	constructor(override http: HttpClient) {
		super(http)
	}

	/** Pede o livro. Com uma geração na fila ou em andamento, devolve ela em vez de criar outra. */
	request(processId: string) {
		return this.http
			.post<ElectronicProcessBook>(`${this.url}/${this.source}/${processId}/books`, null, { observe: 'response' })
			.pipe(
				map(
					response =>
						({ book: new ElectronicProcessBook(response.body ?? {}), created: response.status === 202 }) as ElectronicProcessBookRequestResult
				)
			)
	}

	/** Gerações do processo, da mais recente para a mais antiga. */
	history(processId: string, page = 0, size = 10) {
		const params = new HttpParams().set('page', page).set('size', size)

		return this.get<Paginate<ElectronicProcessBook>>(`${this.source}/${processId}/books`, params).pipe(
			map(response => ({ ...response, content: (response?.content ?? []).map(it => new ElectronicProcessBook(it)) }))
		)
	}

	detail(processId: string, bookId: string) {
		return this.get<ElectronicProcessBook>(`${this.source}/${processId}/books/${bookId}`).pipe(map(response => new ElectronicProcessBook(response)))
	}

	/** Link para abrir na tela (até 60 min, cortado pelo prazo dos arquivos). 409 se não está pronto, 410 se venceu. */
	viewUrl(processId: string, bookId: string) {
		return this.get<ElectronicProcessBookUrl>(`${this.source}/${processId}/books/${bookId}/view-url`)
	}

	/** Link de download (até 15 min), com o nome do arquivo. */
	downloadUrl(processId: string, bookId: string) {
		return this.get<ElectronicProcessBookUrl>(`${this.source}/${processId}/books/${bookId}/download-url`)
	}
}
